var map = {
	"./GrowthUpsellBox.vue": "4548",
	"./ProUpsellBox.vue": "d7c8",
	"./ResourcesWidget.vue": "dd25",
	"./StatsWidget.vue": "0639",
	"./TemplateSelectWidget.vue": "9c2b",
	"./TopCampaignsWidget.vue": "0887",
	"./UpsellBox.vue": "7d60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ebf";